import { ChainTypeTab } from 'modules/common/components/ChainTypeTab';
import { CodeSnippet } from 'modules/chains/components/CodeSnippet';
import { ConnectionType } from 'modules/chains/constants';
import { Tab, TabsManager } from 'uiKit/TabsManager';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useChainSelectors } from 'modules/chains/components/ChainSelectorsProvider';
import { useTabs } from 'modules/common/hooks/useTabs';

import { CodeSnippetPlaceholder } from '../CodeSnippetPlaceholder';
import { VrpcTechnology, getVrpcCode } from './getVrpcCode';

const titles: Record<VrpcTechnology, string> = {
  [VrpcTechnology.ETHERS]: 'ethers',
  [VrpcTechnology.VIEM]: 'viem',
  [VrpcTechnology.CURL]: 'Curl',
};

const tabs: Tab<VrpcTechnology>[] = Object.values(VrpcTechnology).map(id => ({
  id,
  title: (isSelected: boolean) => (
    <ChainTypeTab content={titles[id]} isSelected={isSelected} />
  ),
}));

export const VrpcCodeSnippet = () => {
  const { isLoggedIn } = useAuth();
  const { group } = useChainSelectors();

  const [processedTabs, selectedTab] = useTabs({ tabs });

  const { code, language } = getVrpcCode({
    shouldAddPrefix: !isLoggedIn,
    technology: selectedTab?.id ?? VrpcTechnology.ETHERS,
    url: group.urls[0]?.rpc,
  });

  return (
    <div>
      <TabsManager<VrpcTechnology>
        selectedTab={selectedTab}
        tabs={processedTabs}
      />
      {code ? (
        <CodeSnippet
          code={code}
          language={language}
          type={ConnectionType.HTTP}
        />
      ) : (
        <CodeSnippetPlaceholder />
      )}
    </div>
  );
};
